export const APP_PRODUCT_NAME = 'marketplace';

export const analyticsProps = { product: APP_PRODUCT_NAME };

export const metaData = { applicationName: APP_PRODUCT_NAME };
